import { render } from "./ContactMe.vue?vue&type=template&id=d08d4a10&scoped=true"
import script from "./ContactMe.vue?vue&type=script&lang=js"
export * from "./ContactMe.vue?vue&type=script&lang=js"

import "./ContactMe.vue?vue&type=style&index=0&id=d08d4a10&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src718038542/src/nickyadvokaat-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d08d4a10"]])

export default __exports__